import { empty } from '@ember/object/computed';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { isPresent } from '@ember/utils';

export default Component.extend({
  classNames: ['input-field'],

  attributeBindings: ['disabled', 'readonly', 'autofocus'],
  classNameBindings: ['isEmpty:empty'],
  validate: false,

  //Enable a character counter on the field
  charCounter: undefined,
  charCountMax: undefined,
  charCountCurrent: computed('value', function(){
    // Calculates character count, taking into account carriage returns and normalizing
    // to match with browser calculations.
    let value = this.get('value');
    if (typeof value === 'string') {
      // return this.get('value').replace(/\n/g, "\r\n").length;
      return value.length;
    }
    return 0;
  }),

  isValid: computed('validate', 'errors', function() {
    return (!this.get('validate') && !isPresent(this.get('errors.firstObject')));
  }),

  isEmpty: empty('value'),
  isInvalid: computed('validate', 'errors', function() {
    return (!this.get('validate') && isPresent(this.get('errors.firstObject')));
  }),
  isHidden: computed('readonly', 'value', function () {
    return this.get('readonly') && !this.get('value');
  }),
  id: computed('elementId', function() {
    return `${this.get('elementId')}-input`;
  }),

  active: computed('value', function () {
    let value = this.get('value');
    return isPresent(value) ? 'active' : null;
  })
});
